"use strict";

(function ($) {
	// Mobile Menu
	$(".open-menu-btn").click(function () {
		$("header nav").toggleClass("open");
		$(".open-menu-btn").toggleClass("open");
	});

	// Contact Form 7
	// Scroll to invalid field on failed submit
	$(document).ready(function () {
		$(".wpcf7").on("wpcf7:invalid", function (e) {
			if ($("header").css("height") === "60px") {
				// Mobile view
				$("html, body").animate(
					{ scrollTop: $(".wpcf7-not-valid").first().offset().top - 120 },
					250
				);
			} else {
				$("html, body").animate(
					{ scrollTop: $(".wpcf7-not-valid").first().offset().top - 200 },
					250
				);
			}
		});
	});

	// HTTP Get Variables
	// var variable = $_GET('variable-name')
	function $_GET(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return "";
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	/*  Smooth Scroll
      Assign link .smooth-scroll
      data-target="#elementToScrollTo"
      (optional) data-offset="true" - For use with fixed header
      (optional) data-scroll-speed="timeInMilliseconds" */
	$(".smooth-scroll").click(function (e) {
		e.preventDefault();
		var target,
			speed,
			offset = 0;

		if ($(this).data("offset")) {
			offset = $("#site-header").height();
		}

		if ($(this).data("target")) {
			target = $(this).data("target");
		} else {
			target = $(this).parents(".section").next(".section");
		}

		if ((speed = $(this).data("scroll-speed")));

		$("html, body").animate(
			{
				scrollTop: $(target).offset().top - offset,
			},
			speed
		);
	});

	/*  Mobile menu
      fixed when scroll up */

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = jQuery("header").outerHeight();

	jQuery(window).scroll(function (event) {
		didScroll = true;
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = jQuery(this).scrollTop();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) return;

		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight) {
			// Scroll Down
			jQuery("header").removeClass("nav-down").addClass("nav-up");
		} else {
			// Scroll Up
			if (st + jQuery(window).height() < jQuery(document).height()) {
				jQuery("header").removeClass("nav-up").addClass("nav-down");
			}
		}

		lastScrollTop = st;
	}

	/**
	 * Tabs / Accordion Block
	 */
	$("body").on("click", ".tabs-accordion .tab-title", function () {
		changeTab(this);
	});

	$("body").on("keypress", ".tabs-accordion .tab-title", function (e) {
		if (e.which == 13) {
			changeTab(this);
		}
	});

	function changeTab(el) {
		if (
			$(el).css("display") === "inline-block" &&
			!$(this).hasClass("active")
		) {
			// Tabs
			$(
				".tabs-accordion .tab-title.active, .tabs-accordion .tab-content.active"
			)
				.removeClass("active")
				.attr("aria-selected", false);
			$(el).addClass("active").attr("aria-selected", true);
			$(el).next(".tab-content").addClass("active");
		} else {
			// Accordion
			let expanded = true;
			if ($(el).attr("aria-expanded") == "true") {
				expanded = false;
			}
			$(el).toggleClass("active").attr("aria-expanded", expanded);
			$(el)
				.next(".tab-content")
				.slideToggle(300, function () {
					$(this).next(".tab-content").toggleClass("active");
				});
		}
	}

	// Homepage Slider
	$(".home-slider .ul").slick({
		prevArrow: $(".home-slider .arrows .arrow.prev"),
		nextArrow: $(".home-slider .arrows .arrow.next"),
		autoplay: true,
		autoplaySpeed: 7000,
		dots: false,
		appendDots: $(".home-slider .pagination"),
	});

	if ($(".home-slider .video").length) {
		$(".home-slider .video")[0].play();
	}

	$(".home-slider .slick-slide").focusin(function () {
		$(this).parents(".home-slider").addClass("active");
	});

	$(".home-slider .slick-slide").focusout(function () {
		$(this).parents(".home-slider").removeClass("active");
	});

	// Information Slider
	$(".information-slider").slick({
		prevArrow: $("#information .arrow.prev"),
		nextArrow: $("#information .arrow.next"),
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: false,
					centerMode: true,
					centerPadding: "100px",
				},
			},
			{
				breakpoint: 576,
				settings: "unslick",
			},
		],
	});

	// Explore Slider
	$(".explore-slider .container .slider").slick({
		prevArrow: $(".explore-slider .arrow.prev"),
		nextArrow: $(".explore-slider .arrow.next"),
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					centerMode: true,
					centerPadding: "100px",
				},
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					centerMode: true,
					centerPadding: "60px",
				},
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					centerMode: true,
					centerPadding: "40px",
				},
			},
		],
	});

	// Cards
	$(".explore-card").hover(
		function () {
			$(this).find(".description").stop().slideDown();
		},
		function () {
			$(this).find(".description").stop().slideUp();
		}
	);

	// Menu
	function closeMenus() {
		$(".with-slideout").removeClass("open").attr("aria-expanded", false);
		$(".pull-out-menu-wrapper").removeClass("open");
		$("body").removeClass("no-scroll");
	}

	$(".pull-out-menu-wrapper .overlay").click(function () {
		closeMenus();
	});

	$(document).on("keyup", function (e) {
		if (e.which === 27) {
			closeMenus();
		}
	});

	$("#site-header .with-slideout")
		.click(function () {
			toggleMainMenu(this);
		})
		.on("keypress", function (e) {
			if (e.which === 13) {
				toggleMainMenu(this, true);
			}
		});

	function toggleMainMenu(el, keyboard) {
		$(el).toggleClass("open");

		// $(".more-nav-left li").first().trigger("mouseenter");

		if ($(el).hasClass("open")) {
			$("body").addClass("no-scroll");
			$(el).attr("aria-expanded", true);
			let target = $(el).data("target");
			$(".with-slideout").each(function () {
				if ($(this).data("target") !== target) {
					$(this).removeClass("open").attr("aria-expanded", false);
					$($(this).data("target")).removeClass("open");
				}
			});
			$(target).addClass("open");
			setTimeout(function () {
				if (keyboard) {
					$(target).find("li a:not(:hidden), input").first().focus();
				} else {
					$(target).focus();
				}
			}, 200);
		} else {
			closeMenus();
		}
	}

	// Sidebar Mobile Menu

	$(".mobile-menu aside .toggle").click(function () {
		$(".mobile-menu aside .menu").slideToggle();
	});

	// Victim Support Services
	$(
		"#crime-map .crime-location, #mobile-crime-locations .mobile-crime-location"
	).click(function (e) {
		e.preventDefault();
		let location = $(this).data("location");
		let crime = $("#crime-map").data("crime");
		filterCrimes(this, location, crime);
		return false;
	});

	$(
		"#crime-map .crime-location, #mobile-crime-locations .mobile-crime-location"
	).on("keypress", function (e) {
		if (e.which == 13) {
			let location = $(this).data("location");
			let crime = $("#crime-map").data("crime");
			filterCrimes(this, location, crime);
		}
	});

	function filterCrimes(el, location, crime) {
		$("#results").slideUp();
		$("#crime-map").addClass("loading");
		$("#crime-map .crime-location").removeClass("selected");
		$(el).addClass("selected");
		$.ajax({
			type: "GET",
			cache: false,
			data: {
				location: location,
				crime: crime,
			},
			dataType: "json",
			url: theme.url + "/includes/ajax/get-victim-support-services.php",
			success: function (results) {
				let html = "";
				if (results.success) {
					results.data.forEach((result) => {
						html += `<div class="result">
            <h4>${result.name}</h4>
            <div class="content">${result.content}</div>`;
						if (result.phone_numbers != null && result.phone_numbers.length) {
							html += '<div class="phone-numbers with-icon">';
							result.phone_numbers.forEach((phone) => {
								html += `<div class="number">
                <a href="tel:${phone.number}" target="_blank">${phone.number}</a>`;
								if (phone.label) {
									html += ` <span class="label">(${phone.label})</span>`;
								}
								html += "</div>";
							});
							html += "</div>";
						}
						if (result.email != null && result.email.length) {
							html += `<div class="email with-icon">
              <a href="mailto:${result.email}" target="_blank">${result.email}</a>
            </div>`;
						} else if (result.website != null && result.website.length) {
							html += `<div class="email with-icon">
              <a href="${result.website}" target="_blank">Contact form on website</a>
            </div>`;
						}
						if (result.website != null && result.website.length) {
							html += `<a class="btn website-link" target="_blank" href="${result.website}">Go to website</a>`;
						}
						html += "</div>";
					});
					$("#results").html(html);
				} else {
					$("#results").html(results.message);
				}
				$("#results").slideDown(function () {
					$("#crime-map").removeClass("loading");
					$("html, body").animate(
						{
							scrollTop:
								$("#results").offset().top - $("#site-header").height() - 32,
						},
						500
					);
				});
			},
			error: function () {
				$("#results").html(results.message);
				$("#results").slideDown(function () {
					$("#crime-map").removeClass("loading");
					$("html, body").animate(
						{
							scrollTop:
								$("#results").offset().top - $("#site-header").height() - 32,
						},
						500
					);
				});
			},
		});
	}

	// Modal Focus Trapping
	$(".modal").on("keydown", function (e) {
		const focusableElements =
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
		const firstElement = $(this).find(focusableElements).first()[0];
		const lastElement = $(this).find(focusableElements).last()[0];
		if (e.shiftKey && e.keyCode === 9) {
			console.log(document.activeElement);
			console.log(firstElement);
			if (document.activeElement === firstElement) {
				$(lastElement).focus();
				return false;
			}
		} else if (e.keyCode === 9) {
			if (document.activeElement === lastElement) {
				$(firstElement).focus();
				return false;
			}
		}
	});

	// Downloads Modal
	$(".download.multiple").click(function () {
		openDownloadsModal(this);
	});

	$(".download.multiple").on("keypress", function (e) {
		if (e.which == 13) {
			openDownloadsModal(this);
		}
	});

	function openDownloadsModal(el) {
		$(el)
			.next(".modal")
			.fadeIn("fast")
			.css("display", "flex")
			.find(".close")
			.focus();
		$("body").addClass("no-scroll");
	}

	$(".modal .close").on("keypress", function (e) {
		if (e.which == 13) {
			closeModal();
		}
	});

	$(".modal").click(function (e) {
		if (e.target !== this && e.target.className !== "close") return;
		closeModal();
	});

	// Meet the Team Modal
	$(".staff-member .read-more").on("keypress", function (e) {
		if (e.which == 13) {
			openMeetTheTeamModal(this);
		}
	});

	$(".staff-member .read-more").click(function () {
		openMeetTheTeamModal(this);
	});

	function openMeetTheTeamModal(el) {
		$(el)
			.parents(".staff-member")
			.find(".modal")
			.fadeIn("fast")
			.css("display", "flex")
			.attr("aria-hidden", false)
			.find(".close")
			.focus();
		$("body").addClass("no-scroll");
	}

	/**
	 * Slider Carousel Block
	 */
	$(".slider-carousel .slider").slick({
		prevArrow: $(".slider-carousel .arrows .arrow.prev"),
		nextArrow: $(".slider-carousel .arrows .arrow.next"),
		dots: true,
		appendDots: $(".slider-carousel .slider-pagination"),
	});

	$(".slider-carousel .slick-slide").focusin(function () {
		$(this).parents(".slider-carousel").addClass("active");
	});

	$(".slider-carousel .slick-slide").focusout(function () {
		$(this).parents(".slider-carousel").removeClass("active");
	});

	// Social Popup
	$("body").on("click", ".social-modal-open", function (e) {
		e.preventDefault();
		let title = $(this).data("title");
		let url = $(this).data("url");
		let excerpt = $(this).data("excerpt");
		openSocialModal(title, url, excerpt);
	});

	$("body").on("keypress", ".social-modal-open", function (e) {
		if (e.which == 13) {
			let title = $(this).data("title");
			let url = $(this).data("url");
			let excerpt = $(this).data("excerpt");
			openSocialModal(title, url, excerpt);
		}
	});

	function openSocialModal(title, url, excerpt) {
		let facebookUrl = `https://www.facebook.com/sharer.php?u=${url}`;
		let twitterUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}&via=WestMidsPCC`;
		//let linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${excerpt}&source=West Midlands PCC`;
		$(".social-share-popup .facebook").attr("href", facebookUrl);
		$(".social-share-popup .twitter").attr("href", twitterUrl);
		//$('.social-share-popup .linkedin').attr('href', linkedinUrl);
		$(".social-share-popup")
			.fadeIn()
			.css("display", "flex")
			.attr("aria-hidden", false)
			.find(".close")
			.focus();
		$("body").addClass("no-scroll");
	}

	function closeModal() {
		$(".social-share-popup, .modal").fadeOut().attr("aria-hidden", true);
		$("body").removeClass("no-scroll");
	}

	// BrowseAloud Styles
	let interval = null;
	$(function () {
		interval = setInterval(setBAStyles, 500);
	});

	function setBAStyles() {
		if ($("#__ba_panel, #_ba_corner").length) {
			$("#__ba_panel, #_ba_corner").addClass("Active_ba_corner");
			clearInterval(interval);
		}
	}

	//QUICK ESCAPE
	function leaveQuickly() {
		if ($(".leave-quickly").length) {
			$("body").hide();
			// Get away right now
			window.open("http://www.bbc.co.uk/weather", "_newtab");
			// Replace current site with another site
			window.location.replace("https://www.google.com/");
		}
	}

	$(".leave-quickly").on("click", function (e) {
		leaveQuickly();
	});

	$(document).keyup(function (e) {
		if (e.keyCode == 27) {
			// escape key
			leaveQuickly();
			closeModal();
		}
	});

	// Job Vacancy Document Uploads
	$("body").on("click", ".add-another-upload", function () {
		$(this).parent().removeClass("show-add-file");
		$(this)
			.parent()
			.next(".document-upload.hidden")
			.removeClass("hidden")
			.addClass("show-add-file");
	});

	// Newsletter form
	$(".newsletter-form").submit(function (e) {
		if (
			$(".monthly-newsletter-checkbox:checked").length === 0 &&
			$(".news-alerts-checkbox:checked").length === 0
		) {
			e.preventDefault();
			$(this).find(".error-message").css("display", "inline-block");
		} else {
			$(this).find(".error-message").hide();
		}
	});

	window.setTimeout(function () {
		$(
			"#moove_gdpr_cookie_info_bar:not(.moove-gdpr-info-bar-hidden) .change-settings-button"
		)
			.attr("tabindex", 2)
			.attr("role", "button")
			.on("keypress", function (e) {
				if (e.which == 13) {
					$(this).click();
				}
			});
		$(
			"#moove_gdpr_cookie_info_bar:not(.moove-gdpr-info-bar-hidden) .mgbutton.moove-gdpr-infobar-allow-all"
		)
			.html('Accept<span class="sr-only"> Cookies</span>')
			.attr("tabindex", 1);
		$("#moove_gdpr_cookie_info_bar:not(.moove-gdpr-info-bar-hidden)")
			.detach()
			.prependTo("body");
	}, 500);

	/**
	 * Map locations block
	 */

	let map;
	let markers = [];
	let markerCluster;

	$(".locations-map-form").submit(function (e) {
		e.preventDefault();

		map_error(null);
		$(this).parent().find(".loading").fadeIn().css("display", "flex");

		var values = {};
		$.each($(this).serializeArray(), function (i, field) {
			values[field.name] = field.value;
		});

		if (values.postcode !== "") {
			$.ajax({
				type: "post",
				dataType: "json",
				url: theme.ajaxUrl,
				data: {
					action: "get_map_locations_ajax",
					_ajax_nonce: theme.nonce,
					postcode: values.postcode,
					distance: values.radius,
					post_type: values.post_type,
				},
				success: function (response) {
					if (response.success) {
						remove_markers();
						add_markers(response.results);
						addToList(response.results, true);
						center_map(map);

						markerCluster = new MarkerClusterer(map, markers, {
							imagePath:
								"https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
						});
					} else {
						if (response.results.length === 0) {
							remove_markers();
							emptyList();
							map_error("Sorry there are no results in your area.");
						}
					}
				},
			});
		} else {
			console.log("Get locations error");
		}

		// $('.knife-bins-form .bottom').slideDown().css('display', 'flex');
		$(this).parent().find(".loading").fadeOut();
	});

	if ($(".locations-map").length) {
		$(".locations-map .map").each(function () {
			map = new google.maps.Map($(".locations-map .map")[0], {
				zoom: 14,
				center: { lat: 52.4767439, lng: -1.9057368 },
				streetViewControl: false,
				mapTypeControl: false,
			});

			let post_type = $(this)
				.parents(".wp-block.locations-map-block")
				.find(".map-post-type")
				.val();

			$.ajax({
				type: "post",
				dataType: "json",
				url: theme.ajaxUrl,
				data: {
					action: "get_map_locations_ajax",
					_ajax_nonce: theme.nonce,
					post_type,
				},
				success: function (response) {
					if (response.success) {
						add_markers(response.results);
						addToList(response.results, false);

						center_map(map);

						markerCluster = new MarkerClusterer(map, markers, {
							imagePath:
								"https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
						});
					} else {
						console.log(response.error);
					}
				},
			});
		});
	}

	function map_error(message) {
		if (!message) {
			$(".map-error").hide();
		} else {
			$(".map-error").show();
		}
		$(".map-error .message").html(message);
	}

	function add_markers(locations) {
		markers = locations.map(function (location) {
			let marker = new google.maps.Marker({
				position: {
					lat: parseFloat(location.lat),
					lng: parseFloat(location.lng),
				},
				map: map,
			});

			let content = `<h4>${location.title}</h4>`;

			let infowindow = new google.maps.InfoWindow({
				content: content,
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, "click", function () {
				infowindow.open(map, marker);
			});
			return marker;
		});
	}

	function center_map(map) {
		// vars
		let bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds

		markers.forEach((marker) => {
			var latlng = new google.maps.LatLng(
				marker.position.lat(),
				marker.position.lng()
			);
			bounds.extend(latlng);
		});

		// only 1 marker?
		if (markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			map.setZoom(16);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}

	function emptyList() {
		$(".locations-map .location-list").html("");
	}

	function addToList(locations, showDistance) {
		let html = "";
		locations.forEach((location) => {
			html += `<li>
        <div class="details">
          <div class="title">${location.title}</div>
          <div class="address">${location.address}</div>
        </div>`;
			if (showDistance) {
				html += `<div class="distance">${location.distance} miles away</div>`;
			}
			html += `</li>`;
		});
		$(".locations-map .location-list").html(html);
	}

	function remove_markers() {
		if (!markerCluster) return;
		markerCluster.clearMarkers();
		markers.forEach((marker) => {
			marker.setMap(null);
		});
		markers = [];
	}

	$("#use-my-location").click(function (e) {
		e.preventDefault();
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(setPostcode);
		} else {
			alert(
				"Geolocation is not supported by this browser. Please enter your postcode manually."
			);
		}
	});

	function setPostcode(position) {
		var lat = position.coords.latitude;
		var long = position.coords.longitude;
		var url =
			"https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
			lat +
			"," +
			long +
			"&result_type=postal_code&key=AIzaSyDqVpseIoxdlOe_Pz6dUjqFWdftOZJeAvM";
		$.get(url, function (data) {
			var postcode = data["results"][0]["address_components"][0]["long_name"];
			$('input[name="postcode"]').val(postcode);
			$('input[name="postcode"]').parent().submit();
		});
	}

	$("#map-list-toggle").click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("map")) {
			$(this).removeClass("map").addClass("list").text("View List");
			$(".locations-map .location-list").fadeOut("fast");
			$(".locations-map .map-container").fadeIn("fast");
		} else if ($(this).hasClass("list")) {
			$(this).removeClass("list").addClass("map").text("View Map");
			$(".locations-map .location-list").fadeIn("fast");
			$(".locations-map .map-container").fadeOut("fast");
		}
	});

	// Timeline Modal
	$(".timeline .read-more").on("keypress", function (e) {
		if (e.which == 13) {
			openTimelineModal(this);
		}
	});

	$(".timeline .read-more").click(function () {
		openTimelineModal(this);
	});

	function openTimelineModal(el) {
		$(el)
			.parents(".entry")
			.find(".modal")
			.fadeIn("fast")
			.css("display", "flex")
			.attr("aria-hidden", false)
			.find(".close")
			.focus();
		$("body").addClass("no-scroll");
	}

	$(".stop-search-map path")
		.click(function () {
			goToScrutingPage(this);
		})
		.on("keypress", function (e) {
			if (e.which == 13) {
				goToScrutingPage(this);
			}
		});

	function goToScrutingPage(el) {
		let location = $(el).data("location");
		window.location.href = `${theme.home}/tackling-violence/stop-search/stop-and-search-scrutiny-panels/${location}-stop-and-search-scrutiny-panel/`;
	}

	$(".with-dropdown .dropdown-toggle").on("keypress", function (e) {
		if (e.which == 13) {
			$(this).parent().toggleClass("open");
		}
	});

	/**
	 * Countdown
	 */
	var countDownDate = new Date("May 6, 2021 00:00:00").getTime();
	var countdownInterval = null;

	// Start up
	_installCountdown();

	function _installCountdown() {
		if ($("#election_countdown").length > 0) {
			countdownInterval = setInterval(function () {
				var now = new Date().getTime();

				var distance = countDownDate - now;

				var days = Math.floor(distance / (1000 * 60 * 60 * 24));
				var hours = Math.floor(
					(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
				);
				var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				var seconds = Math.floor((distance % (1000 * 60)) / 1000);

				$("#election_countdown_days").html(days);
				$("#election_countdown_hours").html(hours);
				$("#election_countdown_minutes").html(minutes);
				$("#election_countdown_seconds").html(seconds);

				if (distance < 0) {
					clearInterval(countdownInterval);
					$(".election-countdown").remove();
				}
			}, 1000);
		}
	}

	// play/pause on hero slider
	let pauseButton = document.querySelectorAll(".hero-video-control");
	for (let i = 0; i < pauseButton.length; i++) {
		pauseButton[i].addEventListener("click", pausePlay);
	}

	function pausePlay() {
		let video = document.querySelectorAll(".video");
		let videoControl = document.querySelectorAll(".hero-video-control");
		for (let i = 0; i < video.length; i++) {
			let currentVideo = video[i];
			if (currentVideo.dataset.playState === "play") {
				currentVideo.pause();
				currentVideo.dataset.playState = "paused";
				videoControl[i].innerText = "Play";
				videoControl[i].dataset.buttonText = "Play";
			} else {
				currentVideo.play();
				currentVideo.dataset.playState = "play";
				videoControl[i].innerText = "Pause";
				videoControl[i].dataset.buttonText = "Pause";
			}
		}
	}

	//MORE Navigation

	var timeoutID;

	$(".more-nav-left li")
		.hover(
			function () {
				var children = $(this).children("ul").clone();
				$(".more-nav-right-initial").html(children);
				$(".more-nav-right-sub-menu").empty();
				$(this).addClass("has-children-showing");
			},
			function () {
				$(".has-children-showing").removeClass("has-children-showing");
			}
		)
		.keydown(function (event) {
			if (event.which == 32) {
				var children = $(this).children("ul").clone();
				$(".more-nav-right-initial").html(children);
				$(".more-nav-right-sub-menu").empty();
				$(this).addClass("has-children-showing");
			}
		})
		.keyup(function (event) {
			if (event.which == 32) {
				$(".has-children-showing").removeClass("has-children-showing");
			}
		});

	$(".more-nav-right")
		.on("mouseenter", ".more-nav-right-initial li", function () {
			$(".more-nav-right li.has-children-showing").removeClass(
				"has-children-showing"
			);
			if ($(this).children("ul").length > 0) {
				var subChildren = $(this).children("ul").clone();
				$(".more-nav-right-sub-menu").html(subChildren);
				$(this).addClass("has-children-showing");
			} else {
				$(".more-nav-right-sub-menu").empty();
			}
		})
		.on("mouseleave", ".more-nav-right-initial li", function () {
			timeoutId = setTimeout(function () {
				$(".more-nav-right-sub-menu").empty();
			}, 30000);
		})
		.on("keydown", ".more-nav-right-initial li", function (event) {
			if (event.which == 32) {
				$(".more-nav-right li.has-children-showing").removeClass(
					"has-children-showing"
				);
				if ($(this).children("ul").length > 0) {
					var subChildren = $(this).children("ul").clone();
					$(".more-nav-right-sub-menu").html(subChildren);
					$(this).addClass("has-children-showing");
				} else {
					$(".more-nav-right-sub-menu").empty();
				}
			}
		})
		.on("keyup", ".more-nav-right-initial li", function (event) {
			if (event.which == 32) {
				timeoutId = setTimeout(function () {
					$(".more-nav-right-sub-menu").empty();
				}, 30000);
			}
		});

	$(".mobile-menu-list")
		.on("click", "li", function () {
			$(".mobile-menu-list li")
				.not(this)
				.removeClass("mobile-menu-list-opened");
			$(this).toggleClass("mobile-menu-list-opened");
		})
		.on("keydown", "li", function (event) {
			if (event.which == 32) {
				$(".mobile-menu-list li")
					.not(this)
					.removeClass("mobile-menu-list-opened");
				$(this).toggleClass("mobile-menu-list-opened");
			}
		});

	$(".main-menu-nav li").hover(
		function () {
			$(this).children("a").addClass("hover");
		},
		function () {
			$(this).children("a").removeClass("hover");
		}
	);

	$(".main-menu-nav .with-dropdown")
		.hover(
			function () {
				$(this).children(".sub-menu-0").addClass("hover");
			},
			function () {
				$(this).children(".sub-menu-0").removeClass("hover");
			}
		)
		.keydown(function (event) {
			if (event.which == 39) {
				$(this).children(".sub-menu-0").addClass("hover");
			}
		})
		.keyup(function (event) {
			if (event.which == 39) {
				$(this).children(".sub-menu-0").removeClass("hover");
			}
		});
})(jQuery);
